import { render, staticRenderFns } from "./setService.vue?vue&type=template&id=544ff6d2&scoped=true&"
import script from "./setService.vue?vue&type=script&lang=js&"
export * from "./setService.vue?vue&type=script&lang=js&"
import style0 from "./setService.vue?vue&type=style&index=0&id=544ff6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ff6d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('544ff6d2')) {
      api.createRecord('544ff6d2', component.options)
    } else {
      api.reload('544ff6d2', component.options)
    }
    module.hot.accept("./setService.vue?vue&type=template&id=544ff6d2&scoped=true&", function () {
      api.rerender('544ff6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/setService.vue"
export default component.exports